import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
import { DisplayerService } from 'octali-lib-utils';
import { ResetPasswordPage } from '../reset-password/reset-password.page';
import { SignupPage } from '../signup/signup.page';


@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  
  constructor(
    private route: ActivatedRoute,
    private modalCtrl:ModalController,
    private navCtrl: NavController,
    private displayer:DisplayerService

  ) { 
    
    /*this.subscription = this.route
      .queryParams.subscribe(params => {
        if( params && params.urlReturn)
          this.urlReturn = params.urlReturn;
      });*/
  }

  ngOnInit() {
  }

  login( result ){
    if( result ){
      this.close();
    }
  }

  async signup( result ) {
    if( result ) {
      await this.displayer.presentModal( SignupPage );
      this.close();
    }
  }

  async resetPassword( result ){
    if( result ) {
      await this.displayer.presentModal( ResetPasswordPage );
      this.close();
    }
  }

  async close() {
    const modal = await this.modalCtrl.getTop();
    if(modal)
     modal.dismiss();
  }

  /*async login(loginForm: FormGroup): Promise<void> {
    if (!loginForm.valid) {
      console.log(loginForm.value);
    } else {
      await this.displayer.presentLoader();
      this.profileService.login(loginForm.value.email,loginForm.value.password).then(
        userCredential => {
          this.router.navigate(['home']);    
        }, async error => {
          await this.displayer.dismissLoader();
          await this.displayer.presentAlert("Erreur de connexion","",error.message);
        });
      
    }
  }

  signup() {
    //this.displayer.presentModal(SignupPage);
    this.modalCtrl.dismiss();
  }

  close() {
    this.subscription.unsubscribe();
    this.modalCtrl.dismiss();
  }*/

}
